import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { useEffect } from "react";

import { Toaster } from "react-hot-toast";

import Home from "./pages/Home";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import UserDashboardRoutes from "./pages/UserDashboardRoutes";
import VerifyEmail from "./pages/VerifyEmail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";


// ======================================
// GET USER
// ======================================
const getUser = () => {
  try {

    const rawUser =
      localStorage.getItem("user");

    if (!rawUser) return null;

    const user =
      JSON.parse(rawUser);

    if (
      user?.loginExpiresAt &&
      Date.now() >
      user.loginExpiresAt
    ) {

      localStorage.removeItem(
        "user"
      );

      return null;
    }

    return user;

  } catch {

    return null;
  }
};


// ======================================
// PROTECTED USER ROUTE
// ======================================
const ProtectedUserRoute = ({
  children,
}) => {

  const user = getUser();

  return user &&
    user.role === "user"
    ? children
    : (
      <Navigate
        to="/login"
        replace
      />
    );
};


// ======================================
// PROTECTED ADMIN ROUTE
// ======================================
const ProtectedAdminRoute = ({
  children,
}) => {

  const user = getUser();

  return user &&
    user.role === "admin"
    ? children
    : (
      <Navigate
        to="/login"
        replace
      />
    );
};


function App() {

  // ======================================
  // GLOBAL THEME SYNC
  // ======================================
  useEffect(() => {

    try {     

      const savedTheme =
        localStorage.getItem("theme");

      if (savedTheme === "dark") {

        document.documentElement.classList.add(
          "dark"
        );

      } else {

        document.documentElement.classList.remove(
          "dark"
        );
      }

    } catch (e) {

      console.warn(
        "Theme sync failed:",
        e
      );
    }

  }, []);

  return (
    <Router>

      {/* ======================================
          GLOBAL TOASTER
      ====================================== */}
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{

          duration: 3500,

          style: {
            background: "#111827",
            color: "#fff",
            border:
              "1px solid rgba(255,255,255,0.08)",
            borderRadius: "16px",
            padding: "14px 16px",
            fontSize: "14px",
          },

          success: {
            iconTheme: {
              primary: "#22c55e",
              secondary: "#fff",
            },
          },

          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />

      <Routes>

        {/* ======================================
            PUBLIC ROUTES
        ====================================== */}

        <Route
          path="/"
          element={<Home />}
        />

        <Route
          path="/signup"
          element={<SignupPage />}
        />

        <Route
          path="/login"
          element={<LoginPage />}
        />

        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />

        <Route
          path="/reset-password/:token"
          element={<ResetPassword />}
        />

        <Route
          path="/about"
          element={<About />}
        />

        <Route
          path="/contact"
          element={<Contact />}
        />

        {/* ======================================
            EMAIL VERIFICATION
        ====================================== */}

        <Route
          path="/verify-email"
          element={<VerifyEmail />}
        />

        {/* ======================================
            USER DASHBOARD
        ====================================== */}

        <Route
          path="/user/*"
          element={
            <ProtectedUserRoute>
              <UserDashboardRoutes />
            </ProtectedUserRoute>
          }
        />

        {/* ======================================
            LEGACY DASHBOARD SUPPORT
        ====================================== */}

        <Route
          path="/dashboard/*"
          element={
            <ProtectedUserRoute>
              <UserDashboardRoutes />
            </ProtectedUserRoute>
          }
        />

        {/* ======================================
            ADMIN DASHBOARD
        ====================================== */}

        <Route
          path="/admin/*"
          element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          }
        />

        {/* ======================================
            404 PAGE
        ====================================== */}

        <Route
          path="*"
          element={<NotFound />}
        />

      </Routes>
    </Router>
  );
}

export default App;